import ApiError from "../../errors/ApiError";
import {
  LINK_CUSTOMER_ICNEA_ERROR,
  LINK_CUSTOMER_ICNEA_INVALID_OWNER_ERROR,
  LINK_CUSTOMER_ICNEA_NOT_CONFIGURED_ERROR,
} from "./error-codes.constants";

export class LinkCustomerIcneaError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_ICNEA_ERROR);
  }
}

export class LinkCustomerIcneaInvalidOwnerError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_ICNEA_INVALID_OWNER_ERROR);
  }
}

export class LinkCustomerIcneaNotConfiguredError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_ICNEA_NOT_CONFIGURED_ERROR);
  }
}
